// extracted by mini-css-extract-plugin
export default {"shadow":"Button3d_shadow__+vBYj","edge":"Button3d_edge__Jw7hJ","front":"Button3d_front__o7XQv","text":"Button3d_text__1SXNQ"};